import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="hero-section">
          <h1 className="app-title">LayoutLab</h1>
          <p className="app-tagline">Create beautiful photo collages with ease</p>

          <div className="store-badges">
            <a
              href="https://play.google.com/store/apps/details?id=com.layoutlab.android"
              target="_blank"
              rel="noopener noreferrer"
              className="store-link"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Get it on Google Play"
                className="store-badge"
              />
            </a>
            {/* Uncomment when App Store link is available
            <a
              href="YOUR_APP_STORE_LINK_HERE"
              target="_blank"
              rel="noopener noreferrer"
              className="store-link"
            >
              <img
                src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                alt="Download on the App Store"
                className="store-badge"
              />
            </a>
            */}
          </div>
        </div>

        <div className="features-section">
          <div className="feature">
            <h2>Create with Flexible Layouts</h2>
            <ul>
              <li>Explore modern, classic, and creative collage layouts</li>
              <li>Perfectly fit your photos into each section</li>
              <li>Designed for clean and balanced compositions</li>
            </ul>
          </div>

          <div className="feature">
            <h2>Edit with Precision</h2>
            <ul>
              <li>Adjust brightness, contrast, saturation, temperature, and more</li>
              <li>Edit each photo layer individually</li>
              <li>Reorder, lock, and fine-tune layers with ease</li>
              <li>Use intuitive gestures to move, zoom, and rotate images</li>
            </ul>
          </div>

          <div className="feature">
            <h2>Design with AI (Beta)</h2>
            <ul>
              <li>Choose a theme and select your photos</li>
              <li>Generate a starting layout using AI</li>
              <li>Customize every detail after generation</li>
              <li>A faster way to begin your creative process</li>
            </ul>
          </div>

          <div className="feature">
            <h2>Save, Preview & Share</h2>
            <ul>
              <li>Save drafts and continue editing anytime</li>
              <li>Preview your final design before exporting</li>
              <li>Share high-quality images instantly</li>
            </ul>
          </div>
        </div>

        <div className="description-section">
          <p>
            Whether you're sharing memories, creating stories, or designing visuals for social media,
            LayoutLab gives you full creative control without complexity.
          </p>
        </div>

        <footer className="app-footer">
          <a href="/privacy.html" className="privacy-link">Privacy Policy</a>
        </footer>
      </header>
    </div>
  );
}

export default App;
